import { useEffect, useState } from "react";
import { dashboardAPI } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { DashHero } from "@/components/dashboard/DashHero";
import { PipelinePanel, ScansPanel, ChannelsPanel, FoldersPanel } from "@/components/dashboard/OpsPanels";
import { VolumePanel, FormatsPanel, TopPanel, StockPanel } from "@/components/dashboard/VolumePanels";

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () => dashboardAPI.getOps().then((r) => setData(r.data)).catch(() => toast.error("Errore nel caricamento della dashboard"));
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!data) {
    return (
      <div className="flex items-center justify-center h-96" data-testid="dashboard-loading">
        <Loader2 className="w-8 h-8 animate-spin text-[#E5C158]" />
      </div>
    );
  }

  return (
    <div data-testid="dashboard-page" className="space-y-4 md:space-y-6 text-white">
      <DashHero data={data} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        <div className="md:col-span-2"><PipelinePanel pipeline={data.pipeline} /></div>
        <ChannelsPanel channels={data.channels} />
        <FoldersPanel folders={data.folders} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
        <VolumePanel volume={data.volume} trend={data.trend} />
        <FormatsPanel formats={data.formats} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
        <div className="lg:col-span-4"><ScansPanel scans={data.scans} total={data.scans_total} tiktok={data.tiktok_breakdown} /></div>
        <TopPanel top={data.top_perfumes} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
        <StockPanel items={data.low_stock} />
      </div>
    </div>
  );
}
